export const SubscriptionActionTypes = {
    SUBSCRIPTION_LIST_REQUEST: 'SUBSCRIPTION_LIST_REQUEST',
    SUBSCRIPTION_LIST_REQUEST_SUCCESS: 'SUBSCRIPTION_LIST_REQUEST_SUCCESS',
    SUBSCRIPTION_LIST_REQUEST_ERROR: 'SUBSCRIPTION_LIST_REQUEST_ERROR',

    LOGOUT: 'LOGOUT',

    COMMON_ERROR: 'COMMON_ERROR',

    ADD_SUBSCRIPTION_REQUEST: 'ADD_SUBSCRIPTION_REQUEST',
    ADD_SUBSCRIPTION_REQUEST_SUCCESS: 'ADD_SUBSCRIPTION_REQUEST_SUCCESS',
    ADD_SUBSCRIPTION_REQUEST_ERROR: 'ADD_SUBSCRIPTION_REQUEST_ERROR',
    ADD_SUBSCRIPTION_REQUEST_STATUS: 'ADD_SUBSCRIPTION_REQUEST_STATUS',

    UPDATE_SUBSCRIPTION_REQUEST: 'UPDATE_SUBSCRIPTION_REQUEST',
    UPDATE_SUBSCRIPTION_REQUEST_SUCCESS: 'UPDATE_SUBSCRIPTION_REQUEST_SUCCESS',
    UPDATE_SUBSCRIPTION_REQUEST_ERROR: 'UPDATE_SUBSCRIPTION_REQUEST_ERROR',
    UPDATE_SUBSCRIPTION_REQUEST_STATUS: 'UPDATE_SUBSCRIPTION_REQUEST_STATUS',

    UPDATE_SUBSCRIPTION_STATUS_REQUEST: 'UPDATE_SUBSCRIPTION_STATUS_REQUEST',
    UPDATE_SUBSCRIPTION_STATUS_REQUEST_SUCCESS: 'UPDATE_SUBSCRIPTION_STATUS_REQUEST_SUCCESS',
    UPDATE_SUBSCRIPTION_STATUS_REQUEST_ERROR: 'UPDATE_SUBSCRIPTION_STATUS_REQUEST_ERROR',
    UPDATE_SUBSCRIPTION_STATUS_REQUEST_STATUS: 'UPDATE_SUBSCRIPTION_STATUS_REQUEST_STATUS',

    UPDATE_TRANSACTION_STATUS_REQUEST: 'UPDATE_TRANSACTION_STATUS_REQUEST',
    UPDATE_TRANSACTION_STATUS_REQUEST_SUCCESS: 'UPDATE_TRANSACTION_STATUS_REQUEST_SUCCESS',
    UPDATE_TRANSACTION_STATUS_REQUEST_ERROR: 'UPDATE_TRANSACTION_STATUS_REQUEST_ERROR',
    UPDATE_TRANSACTION_STATUS_REQUEST_STATUS: 'UPDATE_TRANSACTION_STATUS_REQUEST_STATUS',

    NEW_TRANSACTION_REQUEST: 'NEW_TRANSACTION_REQUEST',
    NEW_TRANSACTION_REQUEST_SUCCESS: 'NEW_TRANSACTION_REQUEST_SUCCESS',
    NEW_TRANSACTION_REQUEST_ERROR: 'NEW_TRANSACTION_REQUEST_ERROR',
    NEW_TRANSACTION_REQUEST_STATUS: 'NEW_TRANSACTION_REQUEST_STATUS'
}
